<template>
	<RetrogradeTable />
</template>

<script>
import RetrogradeTable from '@/components/RetrogradeTable/RetrogradeTable'

export default {
	name: "RetrogradePage",
	components: {
		RetrogradeTable
	}
}
</script>

<style scoped>

</style>